import React, { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { motion, AnimatePresence } from "motion/react";

const AnnouncementMarquee = ({ data }) => {
 const [marquee_data, setMarqueeData] = useState(data);

 useEffect(() => {
  if (data && data?.length > 0)
  {
   setMarqueeData(data);
  } else
  {
   setMarqueeData([]);
  }
 }, [data]);

 return (
  <motion.div
   className="announcement-marquee bg-light border rounded p-2"
   initial={{ opacity: 0, y: -10 }}
   animate={{ opacity: 1, y: 0 }}
   transition={{ duration: 0.6, ease: "easeOut" }}
  >
   <Marquee pauseOnHover gradient={false} speed={50}>
    <AnimatePresence>
     {marquee_data?.map((item, index) => (
      <motion.span
       key={index}
       className="me-5"
       initial={{ opacity: 0, y: 10 }}
       animate={{ opacity: 1, y: 0 }}
       exit={{ opacity: 0, y: -10 }}
       transition={{ duration: 0.5 }}
       whileHover={{ scale: 1.05 }}
      >
       <strong>{item.subject}:</strong> {item.marquee_message}
      </motion.span>
     ))}
    </AnimatePresence>
   </Marquee>
  </motion.div>
 );
};

export default AnnouncementMarquee;
